import {GraphicUndersampling} from '../../enum/graphic-undersampling.enum';
import {GraphicGrouping} from '../../enum/graphic-grouping.enum';
import {LocationDataProcessMeasure} from '../offset/LocationDataProcessMeasure';

export class GraphicComponentView {

  public viewProjectId: number;
  public viewName: string;
  public locationSelected: number[] = [];
  public datePickerStart: string;
  public datePickerEnd: string;
  public showAmplitude = true;
  public showAxisManager = true;
  public showEvents = true;
  public showOffset = true;
  public showSms = 2;
  public multiDynamic = true;
  public isDynamicView = false;
  public isFullScreen = false;
  // 'line' , 'area' , 'column' , 'spline' , 'areaspline'
  public chartType = 'spline';
  // 1 to 24
  public frequencyForDataGrouping = 5;
  public periodSelectedForDataGrouping = GraphicGrouping.none;
  public stepInChart = false;
  public underSampling = GraphicUndersampling.fast;
  public opposite = true;

  public unitCollection: GraphicComponentUnit[] = [];

  public description = 'Ceci est une description';
  public featured = true;
  public locationIdEvent = null;
  public locations;
  public thresholdActivated: boolean;
  public thresholdTable?: LocationDataProcessMeasure[];
  public timeZone?: number = 0;
}

export class GraphicComponentUnit {
  unit: string;
  side: GraphicComponentUnitSides;
  visible: boolean;
  min: number = null;
  max: number = null;

  constructor(unitKey: string, index = 0, showingThermalCorrection = false) {
    this.unit = unitKey;
    this.visible = index === 0 || unitKey === 'TEMPERATURE' || showingThermalCorrection;
    this.side = this.unit !== 'TEMPERATURE' ? GraphicComponentUnitSides.left : GraphicComponentUnitSides.right;
  }
}

export enum GraphicComponentUnitSides {
  left = 'left',
  right = 'right'
}
